import React from 'react';

import { PhotosScreen } from '~/components/domain/photos/PhotosScreen';

export default function NetworkPhotos() {
  return <PhotosScreen listType="network" />;
}
